import { LOGO_VARIATION, LOGO_VARIATION_MAP } from "shared/ui/logo/constants";
import { LogoVariationI } from "shared/ui/logo/interfaces";

export const getLogoPath = (variation?: LogoVariationI) =>
  LOGO_VARIATION_MAP[variation as LogoVariationI] ||
  LOGO_VARIATION_MAP[LOGO_VARIATION.DEFAULT];
